import type { Insured, Policy } from "@shared/schema";
import { QuickStatsGrid } from "../QuickStatsGrid";
import { ActivityTimeline } from "../activity-timeline/ActivityTimeline";
import { ContactsSection } from "../contacts/ContactsSection";

interface Props {
  insured: Insured;
  policies: Policy[];
  showAor?: boolean;
}

export function OverviewTab({ insured, policies, showAor = false }: Props) {
  return (
    <div className="space-y-6" data-testid="overview-tab">
      <QuickStatsGrid insured={insured} policies={policies} />
      <ActivityTimeline
        insuredId={insured.id}
        policies={policies}
        showAor={showAor}
      />
      {insured.id && <ContactsSection insuredId={insured.id} />}
    </div>
  );
}
